import React, { useState, useEffect, useRef } from 'react';
import { Sidebar } from 'primereact/sidebar';
import { Divider } from 'primereact/divider';
import { TabView, TabPanel } from 'primereact/tabview';
import { InputSwitch } from 'primereact/inputswitch';
import { InputText } from 'primereact/inputtext';
import { InputNumber } from 'primereact/inputnumber';
import { Dropdown } from 'primereact/dropdown';
import { IconField } from 'primereact/iconfield';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import BotaoSave from '../../../Componentes/BotaoSave';
import DeleteButton from '../../../Componentes/DeleteButton';
import { Icones } from '../../../Componentes/FontConfig';
import ImportListaEnderecosColeta from './ImportListaEnderecosColeta';
import Conexao from '../../../providers/Conexao';



export default function SidebarDCA(props) {
    const {dca, setDca }  = props;
    const [open, setOpen] = useState(false)
    const [index, setIndex] = useState(0);
    const [activeIndex, setActiveIndex] = useState(0);
    const [timeOutRede, setTimeOutRede] = useState(dca.timeoutrede)
    const [timeOutSNMP, setTimeOutSNMP] = useState(dca.timeoutsnmp)
    const [timeOutWeb, setTimeOutWeb]= useState(dca.timeoutweb)
    const [tentativas, setTentativas]= useState(dca.tentativas)
    const [intervaloColeta, setIntervaloColeta]= useState(dca.intervalocoleta)
    const [enderecosColeta, setEnderecosColeta] = useState([])
    const [multCasts, setMultiCasts]= useState([])
    const [comunidades, setComunidades]= useState([])
    const [monitorarRedes, setMonitorarRedes] = useState(dca.monitarredesconectadas)
    const [comunidade, setComunidade] = useState('')
    const [endereco, setEndereco] = useState('')
    const [rede, setRede] = useState('')
    const [faixaEnderecos, setFaixasEndereco]= useState([])
    const [enderecoInicial, setEnderecoInicial]= useState('')
    const [enderecoFinal, setEnderecoFinal]= useState('')
    const [ativo, setAtivo] = useState(dca.ativo === 't')
    const [serviceCollector, setServiceCollector]= useState(true);
    const [serviceInventory, setServiceInventory]= useState(true);
    const [codigoLocalInstalacao, setCodigoLocalInstalacao] = useState(null);
    const  componentMont = useRef(false);

    const validarIP = (ip) =>{
        // Expressão regular para IPv4
        const regexIPv4 = /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
        
        // Expressão regular para IPv6
        const regexIPv6 = /^(?:[a-fA-F0-9]{1,4}:){7}[a-fA-F0-9]{1,4}$/;
        
        // Verifica se o IP corresponde a qualquer uma das expressões regulares
        return regexIPv4.test(ip) || regexIPv6.test(ip);
    }
    const isValidIpFormat = (ip) =>{
        // Função para validar os três primeiros octetos de um endereço IP
        function isValidIpPart(part) {
            const octets = part.split('.');
            if (octets.length !== 3) return false;
            for (let i = 0; i < 3; i++) {
                const num = parseInt(octets[i], 10);
                if (isNaN(num) || num < 0 || num > 255) return false;
            }
            return true;
        }
    
        // Verificar se o endereço termina com ".*"
        if (ip.endsWith('.*')) {
            const ipPart = ip.slice(0, -2); // Remover ".*" para validação dos três primeiros octetos
            return isValidIpPart(ipPart);
        }
        
        return false;
    }


    
    const customHeader = (
        <div className="flex align-items-center gap-2">           
            <span className="font-bold text-xl">CONFIGURAÇÃO DE DCA</span>
        </div>
    );

    const handleTabChange = (e) => {
        setActiveIndex(e.index);
        
       
    };
    const sidebarStyle = {
        minWidth: '70%', 
        transition: 'all 0.5s ease-in-out',
        animation: 'fadeInSidebar 0.3s ease-out' 
    };


    useEffect(() => {
        setCodigoLocalInstalacao(dca.idlocal)
        const safeSplit = (str, fallback = []) =>
            str?.trim() ? str.split(',').map(s => s.trim()) : fallback;
    
        const safeNumber = (value, fallback) =>
            value?.toString().trim() ? Number(value) : fallback;
    
        setIntervaloColeta(safeNumber(dca.intervalocoleta, 60));

        setTimeOutRede(safeNumber(dca.timeoutrede, 32));

        setTimeOutSNMP(safeNumber(dca.timeoutsnmp, 300));

        setTentativas(safeNumber(dca.tentativas, 3));
        setTimeOutWeb(safeNumber(dca.timeoutweb, 10));
    
        setAtivo(dca.ativo === 't');
        setServiceInventory(dca.serviceinventory === 't');
        setServiceCollector(dca.servicecollector === 't');
        setComunidades(safeSplit(dca.comunidades, ['public']));

        setEnderecosColeta(safeSplit(dca.enderecoscoleta));        
        setMultiCasts(safeSplit(dca.multicast));
        setFaixasEndereco(safeSplit(dca.intervaloscoleta));
        if(!dca.chave){
            
        }
        if(!componentMont.current){

            componentMont.current  = true

            if(props.locaisInstalacao?.length === 0 || !props.locaisInstalacao){   
                if(props.getLocaisByCliente) {
                    props.getLocaisByCliente()
                }      
                
                
            }
        }
        
    }, [dca]);

    const updateConfigDca = () =>{
        const dataTemp = {                                           
                    idusuario : dca.idusuario, 
                    idempresa : dca.idempresa, 
                    idcliente : dca.idcliente,
                    chave : dca.chave, 
                    monitarredesconectadas : monitorarRedes ? 't' : 'f', 
                    timeoutweb : timeOutWeb,
                    timeoutrede : timeOutRede, 
                    timeoutsnmp : timeOutSNMP, 
                    tentativas : tentativas , 
                    comunidades :comunidades && comunidades !== '' ?  comunidades.join(',') : '', 
                    intervalocoleta :intervaloColeta  , 
                    enderecoscoleta : enderecosColeta && enderecosColeta !== '' ? enderecosColeta.join(',') : '', 
                    multcasts : multCasts && multCasts !== ''  ? multCasts.join(',') : '', 
                    intervaloColeta : faixaEnderecos && faixaEnderecos != '' ? faixaEnderecos.join(',') : '',
                    ativo : ativo ? 't' : 'f', 
                    serviceCollector : !ativo ? 'f' : (serviceCollector ? 't' : 'f'), 
                    serviceInventory : !ativo ? 'f' : (serviceInventory ? 't' : 'f')                                     
                }

        Conexao.post('dcaController/updateConfigDca', {
            ...dataTemp
            }).then(response=>{
                if(response.status === 200 && response.data.status === 'OK'){
                    props.showMessageToast('success', 'Registro atualizado com sucesso !')
                    setDca([]);
                    setOpen(false)
                   // props.getDca();
                    setIndex(0);
                    
                }else{
                    props.showMessageToast('warn', 'Não foi possível atualizar !')
                     setDca([]);
                    setIndex(0);
                    setOpen(false)
                }
            }).catch(error=>{
                    props.showMessageToast('error', 'Não foi possível atualizar !')
                    console.log(error)
                     setDca([]);
                    setIndex(0);
                    setOpen(false)
            })
    }
    

    const processarIPs = (listaIPs) => {
        // 1. Remove espaços, quebra linhas, e transforma em array único
        let ips = listaIPs
            .split(/[\s,]+/)
            .filter(ip => ip.trim() !== '');

        // 2. Remove duplicados
        ips = Array.from(new Set(ips));

        // 3. Ordena os IPs numericamente
        ips.sort((a, b) => {
            const toNum = ip => ip.split('.').reduce((acc, oct) => acc * 256 + +oct, 0);
            return toNum(a) - toNum(b);
        });

        // 4. Agrupa IPs sequenciais
        const resultado = [];
        let inicio = ips[0];
        let anterior = inicio;

        const ipToNumber = ip => ip.split('.').reduce((acc, oct) => acc * 256 + +oct, 0);
        const numberToIp = num => [24, 16, 8, 0].map(shift => (num >> shift) & 255).join('.');

        for (let i = 1; i <= ips.length; i++) {
            if (i < ips.length && ipToNumber(ips[i]) === ipToNumber(anterior) + 1) {
                anterior = ips[i];
            } else {
                if (inicio === anterior) {
                    resultado.push(inicio);
                } else {
                    resultado.push(`${inicio}-${anterior}`);
                }
                inicio = ips[i];
                anterior = inicio;
            }
        }

        return resultado;
    }



    return (
        <Sidebar 
            onHide={() => {
                props.setDca([]);
                setIndex(0);
                setOpen(false)
            }}
            header={customHeader} 
            visible={dca && dca.iddca} 
            style={sidebarStyle} 
            position="right" 
            className="custom-sidebar"
            {...props}
        >
         <Divider/>   
         <div className="flex flex-wrap gap-1" >  
            <div className="col-12 md:col-3">
                <span className="font-medium text-sm">Chave</span>
                <div className="text-lg">{dca.chave}</div>
            </div>

            <div className="col-12 md:col-2">
                <span className="font-medium text-sm">Versão</span>
                <div className="text-lg">{dca.dcaversao}</div>
            </div>

            <div className="col-12 md:col-4">
                <span className="font-medium text-sm">Sistema Operacional</span>
                <div className="text-lg">{dca.sistemaoperacional}</div>
            </div>

            <div className="col-12 md:col-2">
                <span className="font-medium text-sm">Hostname</span>
                <div className="text-lg">{dca.hostname}</div>
            </div>
            <div className="col-12 md:col-5">
                <span className="font-medium text-sm">Endereço IP</span>
                <div className="text-lg">{dca.enderecoip}</div>
            </div>

            <div className="col-12 md:col-2">
                <span className="font-medium text-sm">Cadastro</span>
                <div className="text-lg">{dca.datacadastro}</div>
            </div>

            <div className="col-12 md:col-2">
                <span className="font-medium text-sm">Instalação</span>
                <div className="text-lg">{dca.dataativacao}</div>
            </div>

            <div className="col-12 md:col-2">
                <span className="font-medium text-sm">Acesso</span>
                <div className="text-lg">{dca.dataatualizacao}</div>
            </div>
         </div>
         {
            (!props.disabledLocais) ? 
         
           <div className="col-12 md:col-4">
                <span className="font-medium text-sm">Local de Instalação</span><br/>
                 <Dropdown  //codigoLocalInstalacao
                    options={props.locaisInstalacao} 
                    value={codigoLocalInstalacao}
                    editable={false} 
                     onChange={(e) => {
                        
                        setCodigoLocalInstalacao(e.value)
                     }}
                    optionLabel="descricao" optionValue="idlocal"
                    placeholder="Informe o local de instalação" className="w-full mt-2"   />
              
            </div> : null }

         <TabView activeIndex={activeIndex} onTabChange={handleTabChange} style={{marginTop : '20px'}}>
                <TabPanel header="Parametros base" leftIcon="pi pi-objects-column mr-2 text-2xl">
                    <span className="font-medium text-lg">Status dos Serviços</span>
                    <div className="flex flex-wrap gap-1" style={{marginTop : '5px'}} >  

                        <div className="col-12 md:col-2">
                            <span className="font-medium text-sm">Módulo Printer DCA</span><br/>
                            <InputSwitch  
                                checked = {serviceCollector}
                                onChange={()=>setServiceCollector(!serviceCollector)}
                                name='servicecollector'
                                style={{marginTop:'5px'}} 
                                tooltip='Esta configurações faz com que o coletor colete dados de impressoras, scanners, multifuncionais e térmicas'/>
                        </div>


                    </div>

                    <div className="flex flex-wrap gap-1" style={{marginTop : '10px'}} >  

                        <div className="col-12 md:col-2">
                            <span className="font-medium text-sm">Módulo Inventory DCA</span><br/>
                            <InputSwitch
                                checked = {serviceInventory}
                                onChange={()=>setServiceInventory(!serviceInventory)}
                                name='serviceinventory'  
                                style={{marginTop:'5px'}} tooltip='Coletar dados de inventário do computador que estiver instalado e enviar para o Datainventory'/>
                        </div>
                        
                    </div>
                    <br/>
                    <span className="font-medium text-lg" style={{marginTop : '20px'}}>Configurações Gerais</span>
                    <div className="flex flex-wrap gap-1" style={{marginTop : '5px'}} > 
                        <div className="col-12 md:col-2">
                            <span className="font-medium text-sm">Intervalo Coleta</span><br/>
                            <Dropdown 
                                value={intervaloColeta} 
                                onChange={(e)=>setIntervaloColeta(e.target.value)}
                                options={[60,90,120,180]} optionLabel="intervalocoleta" 
                                placeholder="Intervalo de coleta" 
                                className="w-full mt-2" 
                                checkmark={true} highlightOnSelect={false} />
                        </div>
                        <div className="col-12 md:col-2">
                            <span className="font-medium text-sm">Timeout Rede {timeOutRede}</span><br/>
                            <InputNumber
                                className="w-full mt-2"
                                value={timeOutRede}
                                onValueChange={(e) => {
                                    const newValue = e.value;

                                    if (newValue !== null && newValue >= 10 && newValue <= 350) {
                                    setTimeOutRede(newValue);
                                    }
                                }}
                                showButtons
                                decrementButtonClassName="p-button-secondary"
                                incrementButtonClassName="p-button-secondary"
                                min={10}
                                max={350}
                                inputProps={{ maxLength: 3 }} // Opcional: impede digitação acima de 3 caracteres
                                />

                        </div>
                        <div className="col-12 md:col-2">
                            <span className="font-medium text-sm">Timeout SNMP</span><br/>
                            <InputNumber
                                className="w-full mt-2" 
                                showButtons 
                                value={timeOutSNMP}                       
                                onValueChange={(e) => {
                                    const newValue = e.value;
                                    if (newValue !== null && newValue >= 10 && newValue <= 350) {
                                        setTimeOutSNMP(newValue);
                                    }
                                }}
                                name='timeoutsnmp'
                                decrementButtonClassName="p-button-secondary" 
                                incrementButtonClassName="p-button-secondary"
                                min={10} max={500} 
                                 />
                        </div>
                        <div className="col-12 md:col-2">
                            <span className="font-medium text-sm">Timeout WEB</span><br/>
                            <InputNumber
                                className="w-full mt-2" 
                                value={timeOutWeb}                       
                                onValueChange={(e) => {
                                    const newValue = e.value;
                                    if (newValue !== null && newValue >= 10 && newValue <= 350) {
                                        setTimeOutWeb(newValue);
                                    }
                                }} 
                                name='timeoutweb'
                                showButtons 
                                decrementButtonClassName="p-button-secondary" 
                                incrementButtonClassName="p-button-secondary"
                                min={10} max={30} 
                                 />
                        </div>

                        <div className="col-12 md:col-2">
                            <span className="font-medium text-sm">Tentativas SNMP</span><br/>
                            <Dropdown 
                                 value={tentativas}
                                 onChange={(e)=>setTentativas(e.target.value)}
                                 name='tentativas'
                               
                                options={[1,2,3,4,5]} optionLabel="name" 
                                placeholder="Tentativas SNMP" 
                                className="w-full mt-2" 
                                checkmark={true} highlightOnSelect={false} />
                        </div>

                    </div>
                    <div className="flex flex-wrap gap-1" style={{marginTop : '10px'}}>  

                        <div className="col-12 md:col-2">
                            <span className="font-medium text-sm">Status DCA</span><br/>
                            <InputSwitch  
                                checked = {ativo}
                                onChange={()=>{
                                    setAtivo(!ativo);
                                }} 
                                name='ativo'
                                style={{marginTop:'5px'}} tooltip='Desabilita totalmente o módulo DCA (essa ação não pode ser revertida)'/>
                        </div>
                        
                    </div>
                    <div className="flex flex-wrap gap-1 justify-end" style={{marginTop : '10px'}}>  
                        <div className="col-12 md:col-3">
                            <Button 
                                disabled={props.loading} 
                                className="w-full text-large" 
                                label="Cancelar" 
                                severity="secondary" 
                                icon='pi pi-times-circle text-2xl' 
                                onClick={() => {
                                        props.setDca([])
                                }} />
                        </div>
                        <div className="col-12 md:col-3">
                            <Button 
                                disabled={props.loading} 
                                className="w-full text-large" 
                                label="Gravar" 
                                severity="primary" 
                                icon='pi pi-save text-2xl' 
                                onClick={() => {
                                        confirmDialog({
                                            message: 'Deseja realmente gravar as alterações do DCA?',
                                            header: 'Confirmação',
                                            icon: 'pi pi-exclamation-triangle',
                                            acceptLabel: 'Sim',
                                            rejectLabel: 'Não',
                                            accept: () => {
                                                  updateConfigDca()
                                            } 
                                        });
                                }} />
                        </div>
                    </div>
                    
                </TabPanel>
                <TabPanel header="Comunidade(s)" leftIcon="pi pi-file-import mr-2 text-2xl">
                <span className="font-medium text-sm ml-2">Adicionar Comunidades SNMP</span><br/>
                <div className="col-12 md:col-6">
                    <IconField iconPosition="right">
                        <InputText
                            className="w-full pr-10" // espaço pro botão
                            value={comunidade}   
                            placeholder='public'
                            onChange={(e)=>setComunidade(e.target.value)}                                                   
                        />
                        <Button
                            icon="pi pi-folder-plus"
                            className="absolute right-2 top-1/2 -translate-y-1/2 ml-2"
                            tooltip='Click para adicionar uma Comunidade SNMP a lista de coleta'
                            onClick={() => {
                                setComunidades([...comunidades, comunidade])
                                setComunidade('')
                            }}
                        />
                    </IconField>
                </div>
                <div className="col-12 md:col-6">
                    <DataTable
                        value={comunidades.map((item, index) => ({ id: index, valor: item }))
                    }
                    paginator
                    rows={10} // Número de itens por página
                    rowsPerPageOptions={[10, 15, 20, 25]} // Opções de páginas
                    responsiveLayout="scroll"
                    paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                    currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords}"
                    >
                        <Column field="valor" header="Comunidade" style={{width : '80%',paddingTop:'4px', paddingBottom: '4px',}}></Column>
                        <Column header="Remover" style={{width : '20%',paddingTop:'4px', paddingBottom: '4px',}} body={(row) => {
                            return (
                            <DeleteButton
                                style ={{paddingTop:'3px', paddingBottom: '3px',}}
                                severity='danger'
                                onClick={() => {
                                    if(comunidades.length > 1){
                                        setComunidades((prevData) =>
                                            prevData.filter((item, i) => i !== row.id) // 'valor' é a string original
                                          )
                                    }else{
                                        props.showMessageToast('warn', 'Não foi possível remover registro, precisa manter ao menos uma comunidade cadastrada')  
                                    }
                                }}
                            />
                            );
                        }}></Column>

                        <div className="flex flex-wrap gap-1" style={{marginTop : '10px'}} > 
                        <div className="col-12 md:col-3"></div>
                        <div className="col-12 md:col-3"></div>
                        </div>
                </DataTable>
                </div>
                
                </TabPanel>
                <TabPanel header="Rede(s)" leftIcon="pi pi-sitemap mr-2 text-2xl">
                <div className="flex flex-wrap gap-1" style={{marginTop : '10px'}} > 
                    <div className="col-12 md:col-3">
                        <span className="font-medium text-lg">Monitorar redes conectadas</span><br/>
                        <InputSwitch
                            checked = {monitorarRedes}
                            onChange={()=>{

                                setMonitorarRedes(!monitorarRedes)

                                if(!monitorarRedes){
                                    
                                    props.showMessageToast('info', 'Você habilitou monitoramento de redes, todas as redes que o computador tiver alcance (placas de rede/wifi) serão monitoradas')  
                                }
                            }}
                            name='serviceinventory'  
                            style={{marginTop:'10px'}} tooltip='Habilita o monitoramento de todas as redes conectadas ao computador em busca de dispositivos.'/>
                    </div>
                </div>
                <Divider/> 
                <span className="font-medium text-sm ml-2">Adicionar Redes (Endereços Multicast)</span><br/>
                <div className="col-12 md:col-6">
                    <IconField iconPosition="right">
                        <InputText
                            className="w-full pr-10" // espaço pro botão
                            value={rede}   
                            placeholder='192.168.0.* ou 10.0.0.* etc'
                            onChange={(e)=>setRede(e.target.value)}                                                   
                        />
                        <Button
                            icon="pi pi-folder-plus"
                            className="absolute right-2 top-1/2 -translate-y-1/2 ml-2"
                            tooltip='Click para adicionar uma Rede (Endereço Multicast) para a lista de coleta'
                            onClick={() => {
                                if(!isValidIpFormat(rede)){
                                    props.showMessageToast('warn', 'Você precisa informar a rede em um formato válido!')  
                                    return
                                }
                                setMultiCasts([...multCasts, rede])
                                setRede('')
                            }}
                        />
                    </IconField>
                </div>
                <div className="col-12 md:col-6">
                    <DataTable
                        value={multCasts.map((item, index) => ({ id: index, valor: item })) }
                        rows={10} // Número de itens por página
                        paginator
                        rowsPerPageOptions={[10, 15, 20, 25]} // Opções de páginas
                        responsiveLayout="scroll"
                        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                        currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords}"
                    >
                        <Column field="valor" header="Rede" style={{width : '80%',paddingTop:'4px', paddingBottom: '4px',}}></Column>
                        <Column header="Remover" style={{width : '20%',paddingTop:'4px', paddingBottom: '4px',}} body={(row) => {
                            return (
                            <DeleteButton
                                style ={{paddingTop:'3px', paddingBottom: '3px',}}
                                severity='danger'
                                onClick={() => {
                                    if(multCasts.length >= 1){
                                        setMultiCasts((prevData) =>
                                            prevData.filter((item, i) => i !== row.id) // 'valor' é a string original
                                          )
                                    }
                                }}
                            />
                            );
                        }}></Column>
                </DataTable>
                </div>
                
                </TabPanel>
                <TabPanel header=" Intervalo(s)" leftIcon="pi pi-share-alt mr-2 text-2xl"  >
                    <span className="font-medium text-sm ml-2">Adicionar Intervalo de coleta</span><br/>
                    <div className="grid gap-0" style={{marginTop : '10px'}}>
                        <div className="col-12 md:col-3">

                                <InputText
                                    className="w-full pr-10" // espaço pro botão
                                    value={enderecoInicial}   
                                    placeholder='Endereço Inicial'
                                    onChange={(e)=>setEnderecoInicial(e.target.value)}                                                   
                                />
                            
                        </div>
                        <div className="col-12 md:col-3">
                            <IconField iconPosition="right">
                                <InputText
                                    className="w-full pr-10" // espaço pro botão
                                    value={enderecoFinal}   
                                    placeholder='Endereço Final'
                                    onChange={(e)=>setEnderecoFinal(e.target.value)}                                                   
                                />
                                <Button
                                    icon="pi pi-folder-plus"
                                    className="absolute right-2 top-1/2 -translate-y-1/2 ml-2"
                                    tooltip='Click para adicionar uma Comunidade SNMP a lista de coleta'
                                    onClick={() => {
                                        if(validarIP(enderecoInicial) && validarIP(enderecoFinal)){
                                            setFaixasEndereco([...faixaEnderecos, enderecoInicial+'-'+enderecoFinal])
                                            setEnderecoInicial('')
                                            setEnderecoFinal('')
                                        }else{
                                            props.showMessageToast('warni', 'Intervalo informado é inválido!')
                                        }
                                    }}
                                />
                            </IconField>
                        </div>
                    </div>
                    <div className="col-12 md:col-6">
                        <DataTable
                                value={faixaEnderecos.map((item, index) => ({ id: index, valor: item }))
                            }
                            paginator
                            rows={10} // Número de itens por página
                            rowsPerPageOptions={[10, 15, 20, 25]} // Opções de páginas
                            responsiveLayout="scroll"
                            paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                            currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords}"
                            >
                                <Column field="valor" header="Faixa" style={{width : '80%',paddingTop:'4px', paddingBottom: '4px',}}></Column>
                                <Column header="Remover" style={{width : '20%',paddingTop:'4px', paddingBottom: '4px',}} body={(row) => {
                                    return (
                                    <DeleteButton
                                        style ={{paddingTop:'3px', paddingBottom: '3px',}}
                                        severity='danger'
                                        onClick={() => {
                                            setFaixasEndereco((prevData) =>
                                                prevData.filter((item, i) => i !== row.id) // 'valor' é a string original
                                            )
                                        }}
                                    />
                                    );
                            }}></Column>
                    </DataTable>
                    </div>
                </TabPanel>
                <TabPanel header="IP(s) / Hostname(s)" leftIcon="pi pi-desktop mr-2 text-2xl">
                
                <span className="font-medium text-sm ml-2">Adicionar Endereços ou Hostname para a lista de coleta</span><br/>
                <div className="col-12 md:col-6">
                    <IconField iconPosition="right">
                        <InputText
                            className="w-full pr-10" // espaço pro botão
                            value={endereco}   
                            placeholder='Endereço/Hostname'
                            onChange={(e)=>setEndereco(e.target.value)}                                                   
                        />
                        <Button
                            icon="pi pi-folder-plus"
                            className="absolute right-2 top-1/2 -translate-y-1/2 ml-2"
                            tooltip='Click para adicionar uma Comunidade SNMP a lista de coleta'
                            onClick={() => {
                                setEnderecosColeta([...enderecosColeta, endereco])
                                setEndereco('')
                            }}
                        />
                    </IconField>
                </div>
                <div className="col-12 md:col-6">
                    <DataTable
                        value={enderecosColeta.map((item, index) => ({ id: index, valor: item }))
                    }
                    paginator
                    rows={10} // Número de itens por página
                    rowsPerPageOptions={[10, 15, 20, 25]} // Opções de páginas
                    responsiveLayout="scroll"
                    paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                    currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords}"
                    >
                        <Column field="valor" header="Endereço/Hostname" style={{width : '80%',paddingTop:'4px', paddingBottom: '4px',}}></Column>
                        <Column header="Remover" style={{width : '20%',paddingTop:'4px', paddingBottom: '4px',}} body={(row) => {
                            return (
                            <DeleteButton
                                style ={{paddingTop:'3px', paddingBottom: '3px',}}
                                severity='danger'
                                onClick={() => {
                                    setEnderecosColeta((prevData) =>
                                        prevData.filter((item, i) => i !== row.id) // 'valor' é a string original
                                      )
                                }}
                            />
                            );
                        }}></Column>
                </DataTable>
                </div>
                </TabPanel>
                <TabPanel header=" Importação" leftIcon="pi pi-arrow-down mr-2 text-2xl"  >
                        <ImportListaEnderecosColeta 
                            setEnderecosColeta ={setEnderecosColeta}
                            setMultiCasts ={setMultiCasts}
                            setFaixasEndereco ={setFaixasEndereco}
                        />
                </TabPanel>
        </TabView>
        </Sidebar>
    );
}
